import { render, staticRenderFns } from "./apptrade.vue?vue&type=template&id=7f281aca"
import script from "./apptrade.vue?vue&type=script&lang=js"
export * from "./apptrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports